import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const baseStylesForSegmentsTable: any = {
    th: {
        fontWeight: 'bold',
        borderTop: 'none !important',
        borderBottom: 'none !important',
        fontSize: '16px',
    },
    td: {
        borderTop: 'none !important',
        borderRight: '1px solid rgba(0,0,0,0.02) !important',
    },
};

export const useStyles = makeStyles(baseStylesForSegmentsTable);

export const SegmentsTotalLabel = styled.span`
    font-size: 16px;
    font-weight: bold;
    margin: 0;
`;

export const SegmentsMonthlyBudgetTotalLabel = styled.span`
    font-size: 14px;
    margin: 0;
`;
